import { useEffect, RefObject } from 'react'

/**
 * Recharts não esconde o tooltip ao tocar fora do gráfico no mobile (não há mouseleave no touch).
 * Simula um mouseleave no .recharts-wrapper quando o toque acontece fora do container.
 */
export function useDismissTooltipOnOutsideTouch(containerRef: RefObject<HTMLDivElement | null>) {
    useEffect(() => {
        const handleTouchStart = (e: TouchEvent) => {
            const container = containerRef.current
            if (!container || container.contains(e.target as Node)) return
            const wrappers = container.querySelectorAll('.recharts-wrapper')
            wrappers.forEach(wrapper => wrapper.dispatchEvent(new MouseEvent('mouseleave', { bubbles: true, cancelable: true })))
        }
        document.addEventListener('touchstart', handleTouchStart)
        return () => document.removeEventListener('touchstart', handleTouchStart)
    }, [containerRef])
}
